// extracted by mini-css-extract-plugin
export default {"sectionContainer":"switch_sectionContainer__5z9ZH","switchCheckbox1":"switch_switchCheckbox1__onRkc","switchLbl":"switch_switchLbl__PTOml","disabled":"switch_disabled__SKqtm"};